import { render, staticRenderFns } from "./albumItem.vue?vue&type=template&id=c725b528&scoped=true&"
import script from "./albumItem.vue?vue&type=script&lang=ts&"
export * from "./albumItem.vue?vue&type=script&lang=ts&"
import style0 from "./albumItem.vue?vue&type=style&index=0&id=c725b528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c725b528",
  null
  
)

export default component.exports